import React from 'react';

import {
    Wrapper,
    Image,
    MainContent,
    Heading,
    Description
} from './HowMuchIsMyHomeWorth.styles';
import homeWorthSvgBVersion from 'public/assets/homepage/second-stepper-couple.png';

import { GetHomeWorthEstimateForm } from 'shared/components/GetHomeWorthEstimateForm/GetHomeWorthEstimateForm';

const headlineText = "Check My Home to see if it's time to sell";
const descriptionText =
    "Get our latest estimate on your property. Discover your home's worth and track it over time.";

const homeWorthSvgDimensions = { width: 589, height: 331 };

export const HowMuchIsMyHomeWorth = () => {
    return (
        <>
            <Wrapper>
                <Image
                    src={homeWorthSvgBVersion}
                    width={homeWorthSvgDimensions.width}
                    height={homeWorthSvgDimensions.height}
                    alt=""
                    loading="lazy"
                />
                <MainContent>
                    <Heading size="4">{headlineText}</Heading>
                    <Description>{descriptionText}</Description>
                    <GetHomeWorthEstimateForm eventCategory="homepage" />
                </MainContent>
            </Wrapper>
        </>
    );
};
